import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ContactViewModel } from '@smarttask-common/src/lib/models/CRM/View/ContactViewModel';

export enum ContactViewActionTypes {
    ADD_CONTACTVIEW = '[ContactView] Create View',
    UPSERT_CONTACTVIEW = '[ContactView] Upsert View',
    ADD_CONTACTVIEWS = '[ContactView] Add Views',
    UPSERT_CONTACTVIEWS = '[ContactView] Upsert Views',
    UPDATE_CONTACTVIEW = '[ContactView] Update View',
    UPDATE_CONTACTVIEWS = '[ContactView] Update Views',
    DELETE_CONTACTVIEW = '[ContactView] Delete View',
    DELETE_CONTACTVIEWS = '[ContactView] Delete Views',
    DELETE_STATE = '[ContactView] Delete State',

    UPDATE_SELECTED_ID = '[ContactView] Update SelectedId',
}

export class UpdateSelectedViewId implements Action {
    readonly type = ContactViewActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_view_id: string) {}
}

export class AddOne implements Action {
    readonly type = ContactViewActionTypes.ADD_CONTACTVIEW;
    constructor(public view: ContactViewModel) {}
}

export class AddMany implements Action {
    readonly type = ContactViewActionTypes.ADD_CONTACTVIEWS;
    constructor(public views: Array<ContactViewModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ContactViewActionTypes.UPSERT_CONTACTVIEW;

    constructor(public view: ContactViewModel) {}
}

export class UpsertMany implements Action {
    readonly type = ContactViewActionTypes.UPSERT_CONTACTVIEWS;
    constructor(public views: Array<ContactViewModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ContactViewActionTypes.UPDATE_CONTACTVIEW;
    constructor(public view_id: string, public changes: Partial<ContactViewModel>) {}
}
export class UpdateMany implements Action {
    readonly type = ContactViewActionTypes.UPDATE_CONTACTVIEWS;
    constructor(public updates: Array<Update<ContactViewModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ContactViewActionTypes.DELETE_CONTACTVIEW;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ContactViewActionTypes.DELETE_CONTACTVIEWS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ContactViewActionTypes.DELETE_STATE;
    constructor() {}
}

export type ContactViewActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedViewId;
